
import { map, Observable } from "rxjs";
import { inject, Injectable } from "@angular/core";
import { CalendarEventPort } from "../ports/calendar-event.port";
import { CalendarEventApiService } from "../services/calendar-event-api.service";
import { CalendarEvent } from "../ports/calendar-event.port";

@Injectable({ providedIn: 'root' })
export class CalendarEventAdapter implements CalendarEventPort {

  private readonly calendarEventApiService = inject(CalendarEventApiService);

  getCalendarEventByIdFromServer(eventId: string): Observable<CalendarEvent | null> {
    return this.calendarEventApiService.getEventById(eventId).pipe(
      map((response) => response as CalendarEvent | null)
    );
  }
}
